import useAuth from './auth';
import useApp from './app';
import useOffline from './offline';
import useUpload from './upload';
import useCows from './cows';

export const auth = useAuth();
export const app = useApp();
export const offline = useOffline();
export const upload = useUpload();
export const cows = useCows();

export default { auth, app, offline, upload, cows };
